<template lang="pug">
	#cookie(v-if="ativo")
		p.texto
			|Nós usamos cookies e tecnologias semelhantes para melhorar sua experiência em nossos serviços e recomendar o
			|melhor conteúdo voltado ao seu interesse. Ao utilizar nossos serviços, você concorda com essas condições. Confira nossa 
			router-link(:to="{ path: '/politica-de-privacidade' }") política de privacidade.
		.buttons
			button(@click="close()") Aceitar cookies
			//- a(href="#") gerenciar cookies

</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
	name: "component-cookie",
	data() {
		return {
			ativo: true,
			form: {
				client: "fael",
				origin: "front",
				userId: uuidv4(),
				cookies: {
					accepted: true,
					getPersonal: true,
					shareAnything: false
				}
			}
		}
	},
	mounted() {
		if(localStorage.getItem('acceptedCookie'))
			this.ativo = false
		else 
			this.ativo = true
	},
	methods: {
		close() {
			this.$axios.post(process.env.VUE_APP_COOKIES, this.form)
				.then(() => {
					localStorage.setItem('acceptedCookie', true)
				})

			this.ativo = false
		}
	}
}
</script>

<style lang="stylus" scoped src="./Cookie.styl"></style>
